import { toast } from "react-toastify";
import { Listes } from "../Types/Listes";
import { ServiceData } from "./Service";

export const onDelete = async (liste: Listes, callback?: () => void) => {
  if (!window.confirm("Voulez-vous vraiment supprimer ce bordereau ?")) return;
  try {
    await ServiceData(`/api/admin/deletebordereau/${liste.id}`, 'DELETE');
    toast.success("Bordereau supprimé avec succès");
    callback?.();
  } catch (err: any) {
    toast.error("Échec de la suppression ou autorisation refusée");
  }
};
export const handleNumBlChange=(form:any,setForm: (data: any) => void,index:number,value:string)=>{
      const updated=[...form.NumBl];
      updated[index]=value;
      setForm({...form,NumBl:updated})
};
export const handleAddNumBl=(form:any,setForm: (data: any) => void)=>{
      setForm({...form,NumBl:[...form.NumBl,'']})
    }
export const handleRemoveNumBl=(form:any,setForm: (data: any) => void,index:number)=>{
      const updated=form.NumBl.filter((_:string,i:number)=> i !==index);
      setForm({...form,NumBl:updated});
    }
export const formatDateHeure = (d: any): string => {
  try {
    const rawDate =
      typeof d === "string" ? d :
      d instanceof Date ? d :
      d?.date ?? null;

    if (!rawDate) return "N/A";

    const date = new Date(rawDate);
    if (isNaN(date.getTime())) return "N/A";

    return date.toLocaleString("fr-FR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch {
    return "N/A";
  }
};

